import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Line } from 'react-chartjs-2';
import services from '@C/Dashboard/Components/Charts/data';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import './styles.scoped.scss';

const chartOptions = {
  scales: {
    x: {
      grid: {
        display: true,
      },
    },
    y: {
      grid: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: true,
    },
  },
};

const barColors = ['#5A89D1', '#D3789E', '#EAAF00', '#72D275', '#A284BA'];

const DashboardCharts = (props) => {
  const [state, setState] = useState({
    time: new Date(),
    fuelList: [],
    date: props.date ? props.date : dayjs().format('YYYY-MM-DD'),
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDSRChart(state.date);
  }, [state.date]);

  const getDSRChart = (date) => {
    services
      .getDSRChart(date)
      .then((response) => {
        const chartData = {
          labels: response.data.data.product_wise.map((item) =>
            item.product === 'Lube' ? 'Products' : item.product,
          ),
          datasets: [
            {
              label: 'Sales rate by value',
              data: response.data.data.product_wise.map((item) =>
                item.total_sale_value.toFixed(2),
              ),
              backgroundColor: barColors[0],
              borderColor: barColors[0],
              borderWidth: 2,
              fill: false,
            },
            {
              label: 'Sales rate by liters',
              data: response.data.data.product_wise.map((item) =>
                item.total_sale_in_liters.toFixed(2),
              ),
              backgroundColor: barColors[1],
              borderColor: barColors[1],
              borderWidth: 2,
              fill: false,
            },
          ],
        };
        setState((prevState) => ({
          ...prevState,
          fuelList: chartData,
        }));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const { fuelList } = state;

  if (loading) {
    return <DropLoaderLarge />;
  }

  return (
    <>
      <section className="widget">
        <header>
          <div className="stock-info-header">
            <h3>Sales Rate</h3>
          </div>
          <div className="input-wrapper">
            <input
              className="cstm-date-input"
              type="date"
              value={state.date}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  date: e.target.value,
                }))
              }
            />
          </div>
        </header>
        <div className="chart-container">
          <Line data={fuelList} options={chartOptions} />
        </div>
      </section>
    </>
  );
};

export { DashboardCharts };
